import { render, staticRenderFns } from "./baseBlMode.vue?vue&type=template&id=fd186b7a&"
import script from "./baseBlMode.vue?vue&type=script&lang=js&"
export * from "./baseBlMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd186b7a')) {
      api.createRecord('fd186b7a', component.options)
    } else {
      api.reload('fd186b7a', component.options)
    }
    module.hot.accept("./baseBlMode.vue?vue&type=template&id=fd186b7a&", function () {
      api.rerender('fd186b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseBlMode.vue"
export default component.exports